import * as React from 'react';
import * as styles from './MaxChildren.css';
import Render from '../../../Shared/Render';

export function MaxChildren({ maxChildren }: { maxChildren: number }) {
	return (
		<Render
				id="maxChildren"
			when={maxChildren > 0}
			withClasses={styles.maxChildren}
		>
			(max {maxChildren})
		</Render>
	);
}
